import {
  GoogleDriveCreateEntireVideoInstanceArgs,
  YoutubeCreateEntireVideoInstanceArgs,
  ZoomCreateEntireVideoInstanceArgs,
} from '@sparemin/api-sdk';
import { MediaImportedArgs } from 'containers/MediaUploadModal/types';

export type MediaImportedProviderArgs =
  | GoogleDriveCreateEntireVideoInstanceArgs
  | ZoomCreateEntireVideoInstanceArgs
  | YoutubeCreateEntireVideoInstanceArgs;

/**
 * Map MediaImportedArgs to the provider-specific identifier fields shared by
 * media upload, entire-video search, and entire-video instance creation.
 */
export function getMediaImportedProviderArgs(
  args: MediaImportedArgs,
): MediaImportedProviderArgs | undefined {
  switch (args.provider) {
    case 'googleDrive':
      return {
        providerUserId: args.providerUserId,
        googleDriveFileId: args.googleDriveFileId,
      };

    case 'zoom':
      return {
        providerUserId: args.providerUserId,
        zoomMeetingId: args.zoomMeetingId,
        zoomRecordingFileId: args.zoomRecordingFileId,
      };

    case 'youtube':
      return { youtubeUrl: args.youtubeUrl };

    default:
      return {} as MediaImportedProviderArgs;
  }
}
